import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Text, Link } from '@sravni/react-design-system/lib/Typography';
import { Heading } from '@sravni/react-design-system/lib/Typography';
import { EmailOpen } from '@sravni/react-icons';
import { useIsPhone } from '@sravni/react-utils';

import { CustomerCare } from '../CustomerCare';
import { PersonalData } from '../PersonalData';
import { SecurityRules } from '../SecurityRules';

import styles from './SecurityBlock.module.scss';

export const SecurityBlock = () => {
  const isPhone = useIsPhone();

  return (
    <Space direction="column" size={isPhone ? 16 : 24}>
      <Space direction="column" size={8}>
        <Heading level={3}>Заботимся о вашей безопасности</Heading>
        <Text strong size={16} className={styles.legalInfoContainer} as="span">
          Для направления писем и запросов государственных органов{' '}
          <span className={styles.legalLinkContainer}>
            <Icon color="blue" icon={<EmailOpen />} className={styles.legalIcon} />
            &nbsp;
            <Link href="mailto:legal@sravni.ru" className={styles.legalLink}>
              {'legal@sravni.ru'}
            </Link>
          </span>
        </Text>
      </Space>
      <Space direction={isPhone ? 'column' : 'row'} size={isPhone ? 16 : 24} wrap>
        <div className={styles.card}>
          <PersonalData />
        </div>
        <div className={styles.card}>
          <SecurityRules />
        </div>
        <div className={styles.card}>
          <CustomerCare />
        </div>
      </Space>
    </Space>
  );
};
